import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { Box, Button, Chip, Typography } from "@mui/material";
import { LogicNameFilter } from "../../utils/constants";

function FilterTrigger({
  displayAs,
  filterName,
  selectedOption,
  options,
  onClick,
  onDelete,
  icon,
  colors,
  filterLogic,
  setFilterLogic,
  fullOptions, // Extract fullOptions prop
  ...props
}) {
  const AndSymbol = () => (
    <Typography variant="caption" component="span">
      {" & "}
    </Typography>
  );
  const OrSymbol = () => (
    <Typography variant="caption" component="span">
      {", "}
    </Typography>
  );
  const chipLabel = () => {
    const labels = [
      <Typography
        variant={selectedOption.length > 0 ? "overline" : "caption"}
        key="filterName"
      >
        {filterName}
      </Typography>,
    ];

    if (selectedOption.length > 0) {
      labels.push(
        <Typography variant="caption" key="is">
          {": "}
        </Typography>
      );

      if (selectedOption.length === 1) {
        labels.push(
          <Typography variant="caption" component="span" key="option0">
            {selectedOption[0]}
          </Typography>
        );
      } else if (selectedOption.length === 2) {
        labels.push(
          <Typography variant="caption" component="span" key="optionLength2">
            {selectedOption[0]}
          </Typography>,
          filterLogic === LogicNameFilter.LOGIC_AND && setFilterLogic ? (
            <AndSymbol key="andSymbolLength2" />
          ) : (
            <OrSymbol key="orSymbolLength2" />
          ),
          <Typography variant="caption" component="span" key="option1">
            {selectedOption[1]}
          </Typography>
        );
      } else if (selectedOption.length === 3) {
        labels.push(
          <Typography variant="caption" component="span" key="optionLength3">
            {selectedOption[0]}
          </Typography>,
          filterLogic === LogicNameFilter.LOGIC_AND && setFilterLogic ? (
            <AndSymbol key="andSymbolOption1" />
          ) : (
            <OrSymbol key="orSymbolOption1" />
          ),
          <Typography variant="caption" component="span" key="option1">
            {selectedOption[1]}
          </Typography>,
          filterLogic === LogicNameFilter.LOGIC_AND && setFilterLogic ? (
            <AndSymbol key="andSymbolOption2" />
          ) : (
            <OrSymbol key="orSymbolOption2" />
          ),
          <Typography variant="caption" component="span" key="option2">
            {selectedOption[2]}
          </Typography>
        );
      } else if (selectedOption.length > 3) {
        labels.push(
          <Typography
            variant="caption"
            component="span"
            key="optionGreaterLength"
          >
            {" one of "}
          </Typography>,
          <Typography variant="caption" component="span" key="selectedLength">
            {selectedOption.length}
          </Typography>,
          <Typography variant="caption" component="span" key="options">
            {" options"}
          </Typography>
        );
      }
    }

    return <>{labels}</>;
  };

  return displayAs === "button" ? (
    <Button
      sx={{
        background: colors.grey_50,
        color:
          selectedOption.length > 0 ? colors.primary_dark : colors.text_primary,
        height: "32px",
        border:
          selectedOption.length > 0
            ? "1px solid " + colors.primary_dark
            : "1px solid " + colors.grey_32percent,
        textTransform: "unset",
        borderRadius: "8px",
        fontSize: "12px",
        display: "flex",
        justifyContent: "space-evenly",
        ...props.sx,
      }}
      startIcon={icon}
      endIcon={
        <KeyboardArrowDownRoundedIcon
          style={{ width: "20px", height: "20px" }}
        />
      }
      disabled={
        options.length === 0 ||
        (options.length === 1 && options[0].name === "All")
      }
      onClick={onClick}
      {...(({ fullOptions, ...rest }) => rest)(props)}
    >
      <Typography variant="caption">{filterName}</Typography>
    </Button>
  ) : (
    <Chip
      onClick={onClick}
      onDelete={onDelete}
      sx={{
        background: colors.common_white,
        color:
          selectedOption.length > 0 ? colors.primary_dark : colors.text_primary,

        height: "32px",
        border:
          selectedOption.length > 0
            ? "1px solid " + colors.primary_dark
            : "1px solid " + colors.grey_32percent,
        textTransform: "unset",
        borderRadius: "8px",
        fontSize: "12px",
        display: "flex",
        padding: "0px",
        justifyContent: "space-evenly",
        "& .MuiChip-deleteIcon": {
          display: selectedOption.length > 0 ? "inline-block" : "none",
        },
        "& .MuiChip-label": {
          padding: selectedOption.length > 0 ? "10px" : "8px",
        },
        "&:hover": {
          background: colors.grey_12percent,
        },

        ...props.sx,
      }}
      icon={icon}
      label={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="caption">{chipLabel()}</Typography>
          {selectedOption.length === 0 && (
            <KeyboardArrowDownRoundedIcon
              style={{ width: "20px", height: "20px", marginRight: "-4px" }}
            />
          )}
        </Box>
      }
      deleteIcon={
        <CancelRoundedIcon
          style={{ width: "16px", color: colors.primary_48percent }}
        />
      }
      disabled={
        options.length === 0 ||
        (options.length === 1 && options[0].name === "All")
      }
      {...(({ fullOptions, ...rest }) => rest)(props)}
    />
  );
}

export default FilterTrigger;
